var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Modal',{attrs:{"title":"待管理","value":_vm.value,"fullscreen":""},on:{"on-visible-change":_vm.visibleChange}},[_c('noManaged',{attrs:{"queryData":_vm.data}}),_c('div',{attrs:{"slot":"footer"},slot:"footer"})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00ac162a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pdReferral/pdScreening/jumpNoManaged.vue
// module id = null
// module chunks = 